<template>
  <div class="d-flex">
    <div class="d-flex justify-content-md-end">
      <v-btn
        color="nitro"
        class="text-white"
        small
        @click="dialog = true"
      >
        <span class="first-letter-capitalize">
          Agendar horário de estudo
        </span>
      </v-btn>
    </div>
    <div class="vuetify">
      <v-dialog
        v-model="dialog"
        max-width="800px"
      >
        <v-card rounded="sm">
          <v-card-title>
            Agendar horários de estudos
          </v-card-title>
          <v-divider />
          <v-card-text>
            <p>Selecione os dias da semana e os horários ideais de estudo que nós adicionamos ao seu calendário.</p>
          </v-card-text>
          <v-card-text>
            <v-card
              rounded="sm"
              class="bg-gray-100"
            >
              <v-card-title>
                <v-row class="d-flex flex-column flex-md-row justify-content-between">
                  <!-- DIA -->
                  <v-col :md="5">
                    <span class="d-flex align-items-center">
                      <span
                        class="font-weight-bold mr-1"
                        style="width: 50px"
                      >
                        Dia: 
                      </span>
                      <span>
                        <v-select
                          v-model="form.day"
                          :items="days"
                          :item-value="'number'"
                          class="bg-white"
                          outlined
                          dense
                        >
                          <template
                            slot="selection"
                            slot-scope="data"
                          >
                            {{ data.item.text }}
                          </template>
                        </v-select>
                      </span>
                    </span>
                  </v-col>
                  <v-col :md="3">
                    <!-- INÍCIO -->
                    <v-dialog
                      ref="begin_modal"
                      v-model="begin_modal"
                      :return-value.sync="form.begin"
                      width="290px"
                    >
                      <template #activator="{ on, attrs }">
                        <span class="px-2 d-flex align-items-center">
                          <span
                            class="font-weight-bold"
                            style="width: 67px"
                          >
                            De:
                          </span>
                          <span
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-text-field
                              v-model="form.begin"
                              append-icon="fa fa-chevron-down font-12"
                              readonly
                              class="bg-white"
                              outlined
                              dense
                            />
                          </span>
                        </span>
                      </template>
                      <v-time-picker
                        v-if="begin_modal"
                        v-model="form.begin"
                        dense
                        color="bg-dark-overlay"
                      >
                        <v-spacer />
                        <v-btn
                          text
                          color="primary"
                          @click="begin_modal = false"
                        >
                          Cancelar
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.begin_modal.save(form.begin)"
                        >
                          OK
                        </v-btn>
                      </v-time-picker>
                    </v-dialog>
                  </v-col>
                  <v-col :md="3">
                    <v-dialog
                      ref="end_modal"
                      v-model="end_modal"
                      :return-value.sync="form.end"
                      width="290px"
                    >
                      <template #activator="{ on, attrs }">
                        <span class="d-flex align-items-center">
                          <span
                            class="font-weight-bold"
                            style="width: 67px"
                          >
                            Ate:
                          </span>
                          <span
                            class="pointer-on-hover"
                            style="width: 200px"
                            v-bind="attrs"
                            v-on="on"
                          >
                            <v-text-field
                              v-model="form.end"
                              append-icon="fa fa-chevron-down font-12"
                              readonly
                              class="bg-white"
                              outlined
                              dense
                            />
                          </span>
                        </span>
                      </template>

                      <v-time-picker
                        v-if="end_modal"
                        v-model="form.end"
                        full-width
                        color="bg-dark-overlay"
                      >
                        <v-spacer />
                        <v-btn
                          text
                          color="primary"
                          @click="end_modal = false"
                        >
                          Cancelar
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="$refs.end_modal.save(form.end)"
                        >
                          OK
                        </v-btn>
                      </v-time-picker>
                    </v-dialog>
                  </v-col>
                  <v-col
                    :md="1"
                    class="d-flex align-items-center justify-content-end"
                  >
                    <button
                      style="height:25px; width:25px"
                      @click="saveSchedule"
                    >
                      <i
                        class="fa fa fa-plus-circle font-19"
                        style="color:#6aaa5c"
                      />
                    </button>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-divider />
              <v-card-text>
                <p class="font-weight-bolder mb-2 text-black">
                  Horários agendados
                </p>
                <ul class="list-unstyled list-schedule pl-0">
                  <li
                    v-for="(schedule, index) in schedules"
                    :key="index"
                    class="d-flex justify-content-between align-items-center"
                  >
                    <span>
                      {{
                        days[schedule.day - 1].text
                      }}, de {{ schedule.begin.split(':')[0] }}h
                      {{
                        schedule.begin.split(':')[1]
                      }}min as {{ schedule.end.split(':')[0] }}h{{ schedule.end.split(':')[1] }}min
                    </span>
                    <button
                      class="schedule-icon"
                      style="height:25px; width:25px"
                      @click="deleteSchedule(schedule)"
                    >
                      <i
                        class="fa fa-times-circle font-19"
                        style="color:#e57373"
                      />
                    </button>
                  </li>
                </ul>
              </v-card-text>
            </v-card>
          </v-card-text>
          <v-divider />
          <v-card-actions class="d-flex justify-content-end">  
            <v-btn
              color="primary"
              @click="dialog = false"
            >
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import {days} from "@/constants/months";

export default {
  data() {
    return {
      schedules: [],
      dialog: false,
      form: {
        day: 1,
        begin: '10:00',
        end: '11:00',
      },
      begin_modal: false,
      end_modal: false,
      days,
    }
  },
  watch: {
    dialog(value) {
      if (!value) {
        this.$emit('closeModal')
      }
    }
  },
  mounted() {
    if (this.$route.query.show_create_schedule) {
      this.dialog = true;
    }
    this.getSchedules()
      .then(r => {
        this.schedules = r.data.data
      })
  },
  methods: {
    saveSchedule() {
      return axios.post('/api/v1/student/schedule', this.form)
        .then(r => {
          this.schedules.push(r.data.data);
          this.updateAuthUserHasSchedules();
          this.$emit('created-schedule');
        });
    },
    getSchedules() {
      return axios.get('/api/v1/student/schedule')
    },
    deleteSchedule(schedule) {
      return axios.delete(`/api/v1/student/schedule/${schedule.id}`)
        .then(() => {
          this.schedules = this.schedules.filter(s => s.id !== schedule.id)
        })
    },
    updateAuthUserHasSchedules() {
      const user = this.$store.state.auth.user;
      user.has_schedule = true;
      this.$store.commit('SET_AUTH_USER', user);
    }
  }

}
</script>

<style scoped>

.schedule-icon svg {
  width: 24px;
  height: 24px;
  background-color: #E4E5E9;
  border-radius: 50%;
  padding: .4em;
}
</style>
